export function fDate(date, locale, timezone) {
    return new Date(date).toLocaleDateString(locale, {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        timeZone: timezone
    });
}

export function fTime(date, locale, timezone) {
    return new Date(date).toLocaleTimeString(locale, {
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
        timeZone: timezone
    });
}

export function fStopwatch(totalSeconds, locale) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const fHours = String(hours).padStart(2, '0');
    const fMinutes = String(minutes).padStart(2, '0');
    const fSeconds = String(seconds).padStart(2, '0');

    return new Date(`1970-01-01T${fHours}:${fMinutes}:${fSeconds}Z`).toLocaleTimeString(locale, {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
        timeZone: 'UTC'
    });
}